export default __webpack_public_path__ + "static/media/happy.3773bf84.svg";